<template>
  <div class="about">
  <div class="item-about">
    <div class="contant-about">
      <div class="img-about">
        <img src="../../assets/image/player_background.png" alt="" />
      </div>
      <div class="text-about">
        <span class="color-fav">عاقلانه </span>
        <span>انتخاب کن و </span>
        <span class="color-love"> عاشقانه </span>
        <span>زندگی کن </span>
      </div>
    </div>
    <div class="social-about" >
      <div class="img-social-about" v-for="item in AllSocial" :key="item.index">
        <router-link :to="item.social_url">
          <img :src="item.social_avatar" alt=""/>
        </router-link>      </div>
    </div>
    <div class="footer-about">
    <span style="white-space: pre-line !important; word-wrap: break-word;" v-html="about_us"> </span>
    </div>
    </div>
  </div>
</template>
<script>
import oracle from "@/oracle";

export default {
  name: "about",
  data(){
    return{
      about_us:'',
      AllSocial:[]
    }
  },
  methods:{
    getList(response) {
      this.AllSocial = response.data
    },
  },
  mounted() {
    this.about_us = oracle.getData("intro").about_us
    oracle.axios("social/getList", null, this.getList);
    this.$root.$emit('content_title', 'درباره ما')

  }
};
</script>
<style>
.about {
  background-image: url("../../assets/image/background.jpg");
  height: auto;
  width: 100%;
  position: relative;
  background-size: cover;
  padding: 15px 0;
  margin-top: -65px;
  overflow: hidden;
}
.item-about{
  overflow: auto;
  height: calc(100% - 60px);
  max-width: 1200px;
  margin: 0 auto;
  margin-top: 60px;
}
.contant-about {
  margin-top: 70px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.img-about {
  width: 110px;
  height: 110px;
  border-radius: 100px;
  overflow: hidden;
  margin: 0 auto;
  box-shadow: 0 3px 10px -5px #000;
}
.img-about img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.text-about {
  padding: 20px 0;
  font-size: 15px;
  font-weight: bold;
}
.color-fav {
  color: green;
}
.color-love {
  color: red;
}
.social-about {
  display: flex;
  background: #fff;
  padding: 10px 0;
  justify-content: center;
  margin: 10px 0;
}
.img-social-about {
  width: 40px;
  height: 40px;
  border-radius: 50px;
  margin: 0 10px;
}
.img-social-about img {
  width: 100%;
  height: 100%;
}
.footer-about{
    background: #fff;
    opacity: 0.5;
    color: #000;
    padding: 10px;
    font-size: 14px;
    margin: 15px;
}
.footer-about p ,
.footer-about span{
    color: #000;
    opacity: 1;
    font-weight: bold;
}
</style>
